import { getAnalyticTags, getChannelTag } from "core/lib/analytics-methods";
import prefixUrl from "core/lib/prefix-url";
import { AppContext } from "core/providers/tv-guide.context";
import context from "core/tv-guide.context";
import { observer } from "mobx-react-lite";
import { useContext } from "react";

type ChannelItemProps = {
  channelNumber: number;
  index: number;
  checkFavourite: (number: number) => void;
  toggleFavourite: (number: number) => void;
}

const ChannelItem = observer((props: ChannelItemProps) => {
  const appContext = useContext(AppContext);
  const store = appContext.store;

  const { channelNumber, index, checkFavourite, toggleFavourite } = props;

  const channel = store.channels[channelNumber];

  if (!channel) {
    return null;
  }

  const key = `c-${index}`;

  const logos = [channel.logo, channel.channelLogoDark, channel.channelLogo];
  let srcUrl = logos.find(x => (x?.length ?? 0) > 1);
  srcUrl = prefixUrl(srcUrl);

  const additionalAttribute = getChannelTag(channel);

  const analytics = getAnalyticTags({
    component_name: "channel_add_to_favourites",
    component_type: "channel_logo_clicks",
    channel_name: `${channel.name}`,
    channel_number: `${channel.number}`,
    target_page_url: "_self"
  });

  const clickToLearnMore = "Click to learn more";

  return (
    <div
      className={"channel-block " + channel.tag + index}
      id={key}
      key={key}>
      <div className="channel-clickable-logo open-popup" {...additionalAttribute}>
        <div className="channel-prefix">
          <span className="icon-info"></span>
        </div>

        <div className="channel-logo">
          {srcUrl && (
            <img
              alt={channel.name}
              className="img-placeholder"
              src={srcUrl}
            />
          )}
        </div>
      </div>

      <div className="channel-block-fav">
        {
          !context.channelTags
            ? <>
              <button
                type="button"
                className={`${checkFavourite(channelNumber)}`}
                {...analytics}
                onClick={() => {
                  if (channel) {
                    toggleFavourite(channelNumber);
                  }
                }}
              />
              <p>{channelNumber}</p>
            </>
            : <span>{channelNumber}</span>
        }
      </div>
      <div className="slider">
        <div className="inner-slider">
          <div className="channel-name">{channel.name}</div>
          <div className="learn-more open-popup" {...additionalAttribute}>{clickToLearnMore}</div>
        </div>
      </div>
    </div>
  );
});

export default ChannelItem;
